export default class Carousel {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        carousels: []
      };

      this.reset();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Sets/Resets the carousels
  //===========================================================================

  reset() {
    this.state.carousels.forEach(($carousel) => {
      $carousel.slick?.('unslick');
    });

    this.state.carousels = [];
    this.setupPdpCarousels();
    this.setupCarousels();
  }

  //===========================================================================
  // Sets up a basic carousel
  //===========================================================================

  setupCarousels() {
    const $carousels = $('.js-carousel');

    $carousels.each((i, carousel) => {
      const $carousel = $(carousel);
      const adaptiveHeight = ($carousel.data('adaptive-height') === false || $carousel.data('adaptive-height') === 'false') ? false : true;
      const centerMode = !!$carousel.data('center-mode');
      const centerModeMobile = !!$carousel.data('center-mode-mobile');
      const autoplay = !!$carousel.data('autoplay');
      const arrows = !!$carousel.data('arrows');
      const dots = !!$carousel.data('dots');
      const fade = !!$carousel.data('fade');
      const infinite = ($carousel.data('infinite') === false || $carousel.data('infinite') === 'false') ? false : true;
      const slidesToShow = $carousel.data('slides-to-show') || 1;
      const slidesToShowTablet = $carousel.data('slides-to-show-tablet') || slidesToShow;
      const slidesToShowMobile = $carousel.data('slides-to-show-mobile') || 1;

      this.state.carousels.push($carousel);

      $carousel.slick?.({
        adaptiveHeight: adaptiveHeight,
        arrows: arrows,
        dots: dots,
        fade: fade,
        autoplay: autoplay,
        infinite: infinite,
        centerMode: centerMode,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1050,
            settings: {
              slidesToShow: slidesToShowTablet
            }
          },
          {
            breakpoint: 750,
            settings: {
              centerMode: centerModeMobile,
              slidesToShow: slidesToShowMobile
            }
          }
        ]
      });
    });
  }

  //===========================================================================
  // Sets up a PDP carousel
  //===========================================================================

  setupPdpCarousels() {
    const $carousels = $('.js-pdp-carousel');

    $carousels.each((i, carousel) => {
      const $carousel = $(carousel);
      const initialSlide = $carousel.data('initial-slide') || 0;
      const vertical = !!$carousel.data('vertical');
      const thumbnails = $carousel.data('thumbnails');

      this.state.carousels.push($carousel);

      if (thumbnails) {
        $carousel.slick?.({
          adaptiveHeight: true,
          arrows: true,
          dots: false,
          draggable: false,
          infinite: false,
          initialSlide: initialSlide,
          slidesToShow: 4,
          slidesToScroll: 4,
          vertical: vertical,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: vertical ? 4 : 3,
                slidesToScroll: vertical ? 4 : 3
              }
            },
            {
              breakpoint: 1050,
              settings: {
                vertical: false,
                verticalSwiping: false,
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 750,
              settings: {
                vertical: false,
                verticalSwiping: false,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      } else {
        $carousel.slick?.({
          adaptiveHeight: true,
          arrows: true,
          dots: true,
          draggable: true,
          infinite: true,
          initialSlide: initialSlide,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1050,
              settings: {
                arrows: false
              }
            }
          ]
        });
      }

      this.initialFilter($carousel);
    });
  }

  //===========================================================================
  // Pauses videos on carousel slide change
  //===========================================================================

  onSlideChange(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-carousel-wrapper');
    const $videos = $parent.find('video');

    $videos.trigger('pause');
  }

  //===========================================================================
  // Plays current video on slide change
  //===========================================================================

  afterPDPSlideChange(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-carousel-wrapper');
    const $activeSlide = $parent.find('.slick-current.slick-active');
    const $video = $activeSlide.find('video');

    $video.trigger('play');
  }

  //===========================================================================
  // Updates the slideshow on thumbnail clicks
  //===========================================================================

  onThumbnailClick(e) {
    const $target  = $(e.currentTarget);
    const $parent  = $target.closest('.js-carousel-wrapper');
    const $slides  = $parent.find('.js-carousel-thumbnail');
    const $mainImg = $parent.find('.js-carousel-main-image');
    const id = $target.data('media-id');

    $slides.removeClass('current');
    $target.addClass('current');

    $mainImg.each((i, img) => {
      let $img = $(img);

      if ($img.data('media-id') === id) {
        $img.removeClass('hidden');
      } else {
        $img.addClass('hidden');
      }
    });
  }

  //===========================================================================
  // Moves carousel left or right
  //===========================================================================

  moveCarousel(e) {
    const $target = $(e.currentTarget);
    const $carousel = $target.closest('.js-carousel-wrapper').find('.js-carousel');

    if ($target.hasClass('prev')) {
      $carousel.slick?.('slickPrev');
    } else {
      $carousel.slick?.('slickNext');
    }
  }

  //===========================================================================
  // Plays/Pauses videos
  //===========================================================================

  videoControls(e) {
    const $target = $(e.currentTarget);
    const $videoWrapper = $target.closest('.js-video-wrapper');
    const $video = $videoWrapper.find('video');

    if ($target.hasClass('play')) {
      $videoWrapper.addClass('play');
      $video.trigger('play');
    } else {
      $videoWrapper.removeClass('play');
      $video.trigger('pause');
    }
  }

  //===========================================================================
  // Filters the carousel on variant changes
  //===========================================================================

  onVariantChange(e) {
    const $target = $(e.currentTarget);
    const $slider = $target.find('.js-pdp-carousel');
    const variant = e.variant;

    if (variant && variant.id) {
      this.filterCarousel($slider, variant.id, variant.title);
    }
  }

  //===========================================================================
  // Filters the carousel on page load
  //===========================================================================

  initialFilter($slider) {
    const variantId = $slider.data('initial-variant-id');
    const variantTitle = $slider.data('initial-variant-title');

    if (variantId && variantTitle) {
      this.filterCarousel($slider, variantId, variantTitle);
    }
  }

  //===========================================================================
  // Filters the carousel for variants
  //===========================================================================

  filterCarousel($slider, variantId, variantTitle) {
    if ($slider.hasClass('slider-filtered')) {
      $slider.slick('slickUnfilter');
    }

    let $slides = $slider.find('.js-carousel-slide');

    $slides.removeClass('filtered');
    $slides.removeClass('current');

    if ($slides.hasClass('filtered')) {
      $slider.slick('slickFilter', '.filtered');
      $slider.addClass('slider-filtered');
      $slides = $slider.find('.js-carousel-slide');
    }

    this.reIndex($slides);
    this.updateMainImage($slides, variantId);
  }

  //===========================================================================
  // Re-indexes the carousel slides after filtering.
  //===========================================================================

  reIndex($slides) {
    let indx = 0;

    $slides.each(function(i, el) {
      let $el = $(el);

      if ($el.hasClass('slick-cloned')) {
        $el.attr('data-slick-index', -1);
      } else {
        $el.attr('data-slick-index', indx);
        indx++;
      }
    });
  }

  //===========================================================================
  // Updates the main PDP image after filtering.
  //===========================================================================

  updateMainImage($slides, variantId) {
    const $slider = $slides.closest('.js-pdp-carousel');
    let index;

    $slides.not('.slick-cloned').each(function(i, slide) {
      let $slide = $(slide);

      if ($slide.attr(`data-${ variantId }`)) {
        index = $slide.data('slick-index');
        $slide.click();
        return false;
      }
    });

    if (index === undefined) {
      $slides.first().click();
      index = 0;
    }

    setTimeout(() => {
      $slider.slick('slickGoTo', index);
    }, 500);
  }


  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-carousel-thumbnail', this.onThumbnailClick.bind(this));
    $(document).on('click', '.js-carousel-thumbnail', this.onSlideChange.bind(this));
    $(document).on('click', '.js-carousel-arrow', this.moveCarousel.bind(this));
    $(document).on('click', '.js-video-button', this.videoControls.bind(this));
    $(document).on('beforeChange', '.js-carousel, .js-pdp-carousel', this.onSlideChange.bind(this));
    $(document).on('afterChange', '.js-pdp-carousel', this.afterPDPSlideChange.bind(this));
    $(document).on('variantChange', '.js-product-wrapper', this.onVariantChange.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
    $(document).on('carousel-reset', this.reset.bind(this));
  }
}
